import {useMemo} from 'react';

import {useSelector} from 'react-redux';

import {selectDishesAdditionalDetails} from '~/shared/store/selectors';

const useShoppingCartDishesQuantity = () => {
  const dishes = useSelector(selectDishesAdditionalDetails);

  return useMemo(() => (!dishes ? 0 : dishes.reduce((acc, dish) => acc + dish.quantity, 0)), [dishes]);
};

export default useShoppingCartDishesQuantity;
